import axios from 'axios'

import { IRoleEnum } from '../types/router'

import axiosAuth from './axiosAuth'

export const postLogin = (email: string, password: string) =>
    axios.post(
        `${process.env.BACKEND_URL}/login`,
        JSON.stringify({ email, password }),
        {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
        }
    )

export const postRegister = (
    username: string,
    email: string,
    password: string,
    role: IRoleEnum
) => axiosAuth.post('/register', { username, email, password, role })

export const putRegisterEmail = (
    email: string,
    password: string,
    new_email: string
) =>
    axiosAuth.put('/register', {
        email,
        password,
        new_email,
    })

export const putRegisterPassword = (
    email: string,
    password: string,
    new_password: string
) =>
    axiosAuth.put('/register', {
        email,
        password,
        new_password,
    })

export const putRegisterName = (email: string, new_username: string) =>
    axiosAuth
        .put('/register', {
            email,
            new_username,
        })
        .catch((error) => {
            throw new Error(error)
        })

export const errorCodes: Record<number, string> = {
    400: 'Missing Username or Password',
    401: 'Unauthorized',
    404: 'Page Not Found - 404',
}

export const logout = () => axiosAuth.get('/logout')
